import { map as mapTE, mapLeft as mapLeftTE } from 'fp-ts/lib/TaskEither';
import { map as mapTO } from 'fp-ts/lib/TaskOption';
import { map as mapE, mapLeft as mapLeftE } from 'fp-ts/lib/Either';
import { map as mapO } from 'fp-ts/lib/Option';

export const tap =
  <T>(op: (data: T) => void) =>
  (a: T) => {
    op(a);

    return a;
  };

export const tapTE = <T>(op: (data: T) => void) => mapTE(tap(op));
export const tapTO = <T>(op: (data: T) => void) => mapTO(tap(op));
export const tapE = <T>(op: (data: T) => void) => mapE(tap(op));
export const tapO = <T>(op: (data: T) => void) => mapO(tap(op));

export const tapLeftTE = <L>(op: (e: L) => void) => mapLeftTE(tap(op));
export const tapLeftE = <L>(op: (e: L) => void) => mapLeftE(tap(op));
